module.exports = __webpack_public_path__ + "d273d9e1ae743a2809756c383fb8f602.svg";